import {MatchDetailsClickEventHandler} from "./match-details.click-event.handler";

export class ScoresListMatchDetailsClickHandler extends MatchDetailsClickEventHandler {
  async action(params) {
    super.action(params);

    this.appStore.state.lastSelectedGameId = params.gameId;
  }
}
